import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HippoConfirmationConfig } from '@hippo/services/confirmation/confirmation.types';
import { HippoConfirmationDialogComponent } from '@hippo/services/confirmation/dialog/dialog.component';
import { merge } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class HippoConfirmationService {
    private _matDialog: MatDialog = inject(MatDialog);
    private _defaultConfig: HippoConfirmationConfig = {
        title: 'Confirm action',
        message: 'Are you sure you want to confirm this action?',
        icon: {
            show: true,
            name: 'heroicons_outline:exclamation-triangle',
            color: 'warn',
        },
        actions: {
            confirm: {
                show: true,
                label: 'Confirm',
                color: 'warn',
            },
            cancel: {
                show: true,
                label: 'Cancel',
            },
        },
        dismissible: false,
        small: false,
    };

    /**
     * Constructor
     */
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    open(
        config: HippoConfirmationConfig = {}
    ): MatDialogRef<HippoConfirmationDialogComponent> {
        // Merge the user config with the default config
        const userConfig = merge({}, this._defaultConfig, config);

        // Open the dialog
        const basePanelClass = userConfig.small
            ? 'hippo-confirmation-dialog-panel-small'
            : 'hippo-confirmation-dialog-panel';
        const extraClasses = userConfig.panelClass
            ? Array.isArray(userConfig.panelClass)
                ? userConfig.panelClass
                : [userConfig.panelClass]
            : [];

        return this._matDialog.open(HippoConfirmationDialogComponent, {
            autoFocus: false,
            disableClose: !userConfig.dismissible,
            data: userConfig,
            width: userConfig.width,
            panelClass: [basePanelClass, ...extraClasses],
        });
    }
}
